import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class LoginValidators {
  /**
   * Valide que la longueur de la valeur est inférieure ou égale à 100 caractères.
   * Si non, retourne l’erreur "LOGIN.MAX_LENGTH" avec le message associé.
   */
  static maxLengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value;
      if (value && value.length > 100) {
        return {
          'LOGIN.MAX_LENGTH':
            'Votre identifiant est trop long. Il doit faire moins de 100 caractères',
        };
      }
      return null;
    };
  }

  /**
   * Valide que la valeur ne contient que des lettres minuscules, des chiffres,
   * ainsi que les symboles autorisés: . (point), - (tiret) et _ (underscore).
   * Si non, retourne l’erreur "LOGIN.INVALID_FORMAT" avec le message associé.
   */
  static formatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value;
      const pattern = /^[a-z0-9._-]+$/;
      if (value && !pattern.test(value)) {
        return {
          'LOGIN.INVALID_FORMAT':
            'Votre identifiant contient des caractères non valides. Seules les lettres minuscules, les chiffres ainsi que le point, le tiret et le underscore sont autorisés',
        };
      }
      return null;
    };
  }
}
